import { render } from "./whats-on-favorites.vue?vue&type=template&id=4cec8a2a"
import script from "./whats-on-favorites.vue?vue&type=script&lang=js"
export * from "./whats-on-favorites.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__